<template>
  <table class="table table-details">
    <tr>
      <td><label>{{ $t('generic.id') }}</label></td>
      <td>{{ details.id }}</td>
    </tr>
    <tr>
      <td><label>{{ $t('generic.created') }}</label></td>
      <td>{{ details.created_at | time}}</td>
    </tr>
    <tr>
      <td><label>{{ $t('generic.updated') }}</label></td>
      <td>{{ details.updated_at | time }}</td>
    </tr>
    <tr>
      <td><label>{{ $t('auditLogs.data.audit_group') }}</label></td>
      <td>{{ details.audit_group }}</td>
    </tr>
    <tr>
      <td><label>{{ $t('auditLogs.data.account_id') }}</label></td>
      <td><router-link v-if="details.account_id" :to="initiatorLink(details)">{{ details.account_id }}</router-link></td>
    </tr>
    <tr>
      <td><label>{{ $t('auditLogs.data.username') }}</label></td>
      <td>{{ details.username }}</td>
    </tr>
    <tr>
      <td><label>{{ $t('auditLogs.data.email') }}</label></td>
      <td>{{ details.email }}</td>
    </tr>
    <tr>
      <td><label>{{ $t('auditLogs.data.action') }}</label></td>
      <td>{{ details.action }}</td>
    </tr>
    <tr>
      <td><label>{{ $t('auditLogs.data.action_result') }}</label></td>
      <td :class="divClassName()">{{ details.action_result }}</td>
    </tr>
    <tr>
      <td><label>{{ $t('auditLogs.data.resource_kind') }}</label></td>
      <td>{{ details.resource_kind }}</td>
    </tr>
    <tr>
      <td><label>{{ $t('auditLogs.data.resource_owner_id') }}</label></td>
      <td><router-link v-if="details.resource_owner_id!==''" :to="accountAuditLogsLink(details.resource_owner_id)">{{
          details.resource_owner_id
        }}
      </router-link></td>
    </tr>
    <tr>
      <td><label>{{ $t('auditLogs.data.resource_id') }}</label></td>
      <td>{{ details.resource_id }}</td>
    </tr>
    <tr>
      <td><label>{{ $t('auditLogs.data.resource_identifier') }}</label></td>
      <td>{{ details.resource_identifier }}</td>
    </tr>
    <tr>
      <td><label>{{ $t('auditLogs.data.message') }}</label></td>
      <td>{{ details.message }}</td>
    </tr>
    <tr>
      <td><label>{{ $t('auditLogs.data.metadata') }}</label></td>
      <td><meta-data-details :data="details.metadata" /></td>
    </tr>


  </table>
</template>
<script>

import MetaDataDetails from "@/components/MetaData/MetaDataDetails.vue";
import linkUtils from "@/util/link_utils";

export default {
  name: 'AuditLogDetails',
  components: {MetaDataDetails},
  props: {
    details: {
      type: Object,
      required: true,
    },
  },
  methods: {
    initiatorLink(row) {
      if (row.audit_group == "user") {
        return linkUtils.accountProfilePath(this.$router, {account_id: row.account_id});
      } else {
        return linkUtils.systemAccountPath(this.$router, {system_account_id: row.account_id});
      }
    },
    accountAuditLogsLink(accountID) {
      return linkUtils.accountAuditLogsPath(this.$router, {account_id: accountID});
    },
    divClassName() {
      if (this.details["action_result"] === "failure") {
        return 'bg-warning';
      }
      return '';
    },
  }
};
</script>
<style></style>
